<template>
    <div>
        <label class="col-form-label pt-0">{{ label }}</label>
        <small v-if="description" class="form-text mb-2">{{ description }}</small>
        <b-form-group v-for="option in options" :key="option.label"
            :label="titleCase(option.label)">
            <b-form-checkbox-group
                v-on:change="(values) => selectOption(option.label, values)"
                :options="option.values"
                :checked="getCheckedOptions(option.label)"
                :name="option.label">
            </b-form-checkbox-group>
        </b-form-group>
    </div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';

export default {
    data () {
        return {
            optionMap: {

            }
        }
    },

    props: [
        'value', 'config', 'label', 'description',
        'required', 'values', 'state', 'error'
    ],

    components: { },

    watch: {

    },

    computed: {
        options() {
            return _.chain(this.values || _.get(this.config, 'values'))
                .reduce((tmp, valueObj) => {
                    const [label, value] = _.get(valueObj, 'id', '').split('.');

                    if (!label) return tmp;

                    const option = {
                        text: value,
                        value,
                        checked: true,
                    }

                    if (tmp[label]) {
                        tmp[label].values.push(option);
                        return tmp;
                    }

                    tmp[label] = { label, values: [option], };
                    return tmp;
                }, {})
                .value()
        }
    },

    methods: {
        titleCase(val) {
            return V.titleCase(val);
        },

        selectOption(label, values) {
            const newValue = _.chain(this.value)
                .split(',')
                .map(keyValuePair => keyValuePair.split('.'))
                .filter(([key, value]) => key != label)
                .concat(values.map(value => ([label, value])))
                .map(([key, value]) => `${key}.${value}`)
                .join(',')
                .value();

            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },

        getCheckedOptions(label) {
            return String(this.value || '')
                .split(',')
                .map(keyValuePair => keyValuePair.split('.'))
                .filter(([key, value]) => key == label)
                .map(([key, value]) => value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/MultiSelectArrayComponent.vue